import { render, staticRenderFns } from "./NoDataPrizeRequest.vue?vue&type=template&id=e8c5555c&scoped=true&"
import script from "./NoDataPrizeRequest.vue?vue&type=script&lang=js&"
export * from "./NoDataPrizeRequest.vue?vue&type=script&lang=js&"
import style0 from "./NoDataPrizeRequest.vue?vue&type=style&index=0&id=e8c5555c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c5555c",
  null
  
)

export default component.exports